<template>
    <q-modal v-model="show_report" :content-css="{minWidth: getMinWidth, maxWidth: getMaxWidth, minHeight: '80vh'}" no-backdrop-dismiss no-esc-dismiss>
        <q-modal-layout>
            <q-toolbar slot="header">
                <q-btn flat round dense @click="show_report = false" icon="fas fa-times" />
                <q-toolbar-title>
                    {{ title }}
                </q-toolbar-title>
            </q-toolbar>

            <div class="layout-padding">
                <q-tabs v-model="tab" color="secondary" class="shadow-1" @select="loadContent">
                    <q-tab slot="title" name="downloads" icon="fal fa-download" :label="$t('downloads')" />

                    <q-tab-pane name="downloads" class="q-px-lg q-pb-xl">
                        <q-table
                            ref="table"
                            :data="downloads"
                            :columns="columns_downloads"
                            row-key="id"
                            :pagination.sync="server_pagination"
                            @request="requestDownloads"
                            :loading="loading"
                            :no-data-label="$t('no_data_avaliable')"
                            :no-results-label="$t('no_results_found')"
                            :loading-label="$t('loading_data')"
                            :rows-per-page-label="$t('items_per_page')"
                            :rows-per-page-options="[5,10,50,100]"
                            binary-state-sort
                            :filter=filter_downloads
                            class="q-mt-lg"
                            >

                            <template slot="top" slot-scope="props" :props="props">
                                <q-search v-model="filter_downloads" icon="far fa-search" :placeholder="$t('search')" :debounce="500" />

                                <div class="col" />

                                <q-btn color="secondary" icon="fas fa-download" :label="$t('downloads_report')" @click="downloadCertificate()" />
                            </template>

                            <q-tr slot="header" slot-scope="props" :props="props">
                                <q-th v-for="col in props.cols" :key="col.name" :props="props">
                                    {{ $t(col.label) }}
                                </q-th>
                            </q-tr>

                            <template slot="body" slot-scope="props">
                                <q-tr :props="props">
                                    <q-td key="user_full_name" :props="props">
                                        {{ props.row.user_full_name }}
                                    </q-td>

                                    <q-td key="user_email" :props="props">
                                        {{ props.row.user_email }}
                                    </q-td>

                                    <q-td key="download_date" :props="props">
                                        {{ fDate(props.row.download_date) }}
                                    </q-td>
                                </q-tr>
                            </template>
                        </q-table>
                    </q-tab-pane>
                </q-tabs>
            </div>
        </q-modal-layout>
    </q-modal>
</template>

<script>
import { mapGetters } from 'vuex'
import { date } from 'quasar'
const { formatDate } = date

export default {
    props: ['show_report_library', 'id', 'title'],

    data() {
        return {
            server_pagination: {
                page: 1,
                rowsNumber: 10,
                rowsPerPage: null,
                descending: false,
                sortBy: null
            },
            downloads: [],
            columns_downloads: [
                {
                    name: 'user_full_name',
                    required: true,
                    label: 'name',
                    align: 'left',
                    field: 'user_full_name',
                    sortable: true,
                },
                {
                    name: 'user_email',
                    required: true,
                    label: 'email',
                    align: 'left',
                    field: 'user_email',
                    sortable: true,
                },
                {
                    name: 'download_date',
                    required: true,
                    label: 'date',
                    align: 'left',
                    field: 'download_date',
                    sortable: true,
                }
            ],
            tab: 'downloads',
            loading: false,
            filter_downloads: ''
        }
    },

    computed: {
        ...mapGetters({
            access_token: 'common/access_token',
            id_user_language_selected: 'common/id_user_language_selected',
            num_rows: 'datatable/num_rows'
        }),

        getHeader() {
            let headers = {}
            return headers = {
                headers: {
                    'content-type': 'application/json',
                    'authorization': 'Basic ' + btoa(process.env.APP_CLIENT_ID + ':' + process.env.APP_CLIENT_SECRET),
                    'authorization': 'Bearer ' + this.access_token
                }
            }
        },

        getMaxWidth() {
            if (this.$q.platform.is.mobile) return '100vw'
            else return '80vw'
        },

        getMinWidth() {
            if (!this.$q.platform.is.mobile) return '90vw'
        },

        show_report: {
            get() {
                return this.show_report_library
            },
            set() {
                this.$emit('hide_report', '')
            }
        },
    },

    methods: {
        loadContent() {
            if (this.show_report_library) {
                if (this.tab === 'downloads') this.requestDownloads({ pagination: this.server_pagination })
            }
        },

        requestDownloads ({ pagination }) {
            this.downloads = []
            this.loading = true
            this.server_pagination = pagination

            let order = pagination.descending ? '-' : ''
            let order_by = pagination.sortBy ? order + pagination.sortBy : ''

            let data = {
                "page_size": this.server_pagination.rowsPerPage,
                "page": this.server_pagination.page,
                "ordering": order_by,
                "search": this.filter_downloads
            }

            this.savePagination()

            this.$axios.get(`/admin_library_files/files/${this.id}/library_file_downloads/?${this.$qs.stringify(data)}`, this.getHeader)
            .then(response => {
                this.server_pagination.rowsNumber = response.data.count

                response.data.results.map((e) => {
                    this.downloads.push(e)
                })

                this.loading = false
            })
            .catch(e => {
                this.loading = false
                console.log(e)
            })
        },

        fDate(d) {
            if (d) {
                let format = ''

                switch(this.id_user_language_selected) {
                    case 1:
                    case 3: format = 'DD/MM/YYYY HH:mm:ss'
                    break
                    default: format = 'MM-DD-YYYY HH:mm:ss'
                    break
                }

                return date.formatDate(d, format)
            }
        },

        savePagination() {
            this.$store.dispatch('datatable/SET_NUM_ROWS', [this.server_pagination.rowsPerPage])
        },

        loadPagination() {
            this.server_pagination.rowsPerPage = this.num_rows
        },

        downloadCertificate() {
            let message = this.$t('generating_import_file_message')
            this.$q.loading.show({
                message
            })
            this.$axios.get(`/admin_library_files/files/${this.id}/library_file_downloads/generate_report/`, this.getHeader)
            .then(response => {
                this.forceFileDownload(response.data.path_url)
            })
            .catch(e => {
                console.log(e)
            })
            .finally(() =>{
                this.$q.loading.hide()
            })
        },

        forceFileDownload(response){
			const link = document.createElement('a')
			link.href = response
			document.body.appendChild(link)
			link.click()
        },
    },

    watch: {
        show_report_library: function() {
            if (this.show_report_library) {
                this.requestDownloads({ pagination: this.server_pagination })
            }
            else {
                this.tab = 'downloads'
            }
        },

        num_rows: {
            handler: function(newValue) {
                this.loadPagination()
            },
            deep: true
        }
    },

    created() {
        this.loadPagination()
    }
}
</script>

<style>

</style>
